// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FSYY","delete":"styles_delete__3W1a_","update":"styles_update__1FDs-","add":"styles_add__7PPqD"};